/**
 * Convierte el `detail` de un error de la API (string, array de errores de
 * validación de FastAPI/Pydantic, u objeto) en un texto legible. FastAPI
 * devuelve 422 como {detail: [{type, loc, msg, ...}, ...]}; pasar ese array
 * directamente a toast.error()/setState() hace que React intente renderizar
 * un objeto como hijo y la página se queda en blanco.
 */
export function getErrorMessage(err, fallback = "Ha ocurrido un error. Inténtalo de nuevo.") {
  const detail = err?.response?.data?.detail ?? err?.detail ?? err;
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg.replace(/^Value error,\s*/i, "") : null))
      .filter(Boolean);
    return msgs.length ? msgs.join(" ") : fallback;
  }
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return fallback;
}
